<template>
  <list-item>
    <list-item-meta
      :description="dataConfig.showCols.desCol&&record[dataConfig.showCols.desCol.propId]||t('描述信息')"
    >
      <template #title>
        <div v-if="dataConfig.showCols.titleCol&&dataConfig.showCols.titleCol.showFlag!==false">
          <link-text :record="record"
                     :showCols="dataConfig.showCols"
                     propName="titleCol"
                     :dataConfig="dataConfig"></link-text>
        </div>
      </template>

      <template #avatar>
        <Avatar  v-if="dataConfig.showCols.userImgCol&&dataConfig.showCols.userImgCol.showFlag!==false">
          <template #icon>
            <a-image
              v-if="dataConfig.showCols.userImgCol&&record[dataConfig.showCols.userImgCol.propId]"
              :width="40"
              :src="(dataConfig.showCols.userImgCol&&record[dataConfig.showCols.userImgCol.propId])"
            />
            <span v-else>
               <UserOutlined />
            </span>
          </template>
        </Avatar>
      </template>
    </list-item-meta>
  </list-item>
</template>

<script lang="ts">
import { ListItem,ListItemMeta,Avatar} from 'ant-design-vue';
import { defineComponent } from 'vue';
import i18n from '@/i18n';

export default defineComponent({
  components: {
    Avatar,
    ListItemMeta,
    ListItem
  },
  columns:[
    {value:'title',label:i18n.global.t('标题信息')},
    {value:'description',label:i18n.global.t('描述信息')},
    {value:'userHeaderUrl',label:i18n.global.t('用户头像')},
  ],
  label:i18n.global.t('用户图标带内容'),
  name: 'userImgAndContent',
});
</script>
<script lang="ts" setup>
import {Image as AImage,Button as AButton,Modal as AModal,Table as ATable} from 'ant-design-vue';
import {UserOutlined} from "@ant-design/icons-vue";
import {useI18n} from "vue-i18n";
import {toRefs} from "vue";
import LinkText from "@/gateway-main/commonVue/link-text.vue";

const {t} = useI18n();


interface propTypes {
  record: any,
  dataConfig: any,
  dateCol:any
};
const props = withDefaults(defineProps<propTypes>(), {
  record: {},
  dataConfig: {},
  dateCol:{}
})
const {dataConfig} = toRefs(props);
if (unref(dataConfig)["showCols"] == null) {
  unref(dataConfig)["showCols"] = {
    desCol: {},
    titleCol: {},
    userImgCol:{}
  };
}

</script>
